import gaDimensionsBuilder from 'helpers/gaDimensionsBuilder'
import { getAppData, setCacheTags, setCanonical } from 'helpers/initializePage'
import { ROUTE_NAMES } from 'routes'
import Home from 'screens/resources/home'
import { contentfulResourcesService } from 'services/contentful'
import getapp from 'services/getapp'
import initializeExperiments from 'services/launchDarkly'

const POSTS_LIMIT = 9
const ROUTE_NAME = 'resources_home'

export const getServerSideProps = async ctx => {
  const contentfulService = contentfulResourcesService({
    preview: ctx.query.preview,
    environment: ctx.req?.headers['fe-contentful-env'],
  })
  const getAppService = getapp(ctx.req)

  const [experiments, posts, topics, contentHubs, user] = await Promise.all([
    initializeExperiments({
      ctx,
      pageType: ROUTE_NAMES.RESOURCES,
    }),
    contentfulService.fetchPosts({ limit: POSTS_LIMIT }),
    contentfulService.fetchTopics().catch(() => []),
    contentfulService.getResourcesContentHubs(),
    getAppService.getUser().catch(() => null),
  ])
  const appData = { ...getAppData(ctx), experiments }
  setCanonical(ctx)
  setCacheTags(ctx, ROUTE_NAMES.RESOURCES)

  ctx.req.APP_DATA = appData // We pass in current Request this info to Document in order to avoid double calculation.
  return {
    props: {
      posts,
      topics,
      contentHubs,
      appData: {
        ...appData,
        user,
        head: {
          google_analytics: {
            dimensions: gaDimensionsBuilder({ route_name: ROUTE_NAME }),
            content_group: ROUTE_NAME,
          },
        },
        route: ROUTE_NAME,
      },
    },
  }
}
export default Home
